export default {
  namespaced: true,
  getters: {
    info(state) {
      return state.info;
    },
    getTypeList(state) {
      return state.typeList;
    },
  },
  state: {
    typeList: [], // 推送时间
    info: {
      name: 'test',
      age: 31,
      title: 'test',
      avatar:
        'https://baike-med-1256891581.file.myqcloud.com/mini_lite/production/static/luoshi/public/empty-doctor.png',
    },
  },
  mutations: {
    set(state, info) {
      state.info = info;
    },
    setTypeList(state, list) {
      state.typeList = list;
    },
  },
  actions: {},
};
